/*
 * @Author: Nora Galvin
 * @Date: 2020-08-19 15:54:57
 * @Last Modified by: Nora
 * @Last Modified time: 2020-10-03 10:12:42
 */
export const interactionsLevel1 = [
  {
    key: 'scroll-into-view',
    name: 'Scroll Into view',
    type: 'level1',
    description: 'Animate when the elements scroll into view or first appear',
  },
  {
    key: 'scrolling-in-view',
    name: 'While scrolling in view',
    type: 'level1',
    description: 'Animate while the elements scroll through view port',
  },
  {
    key: 'after-page-loaded',
    name: 'After page finish loading',
    type: 'level1',
    description: 'Animate trigger after page load',
  },
];

export const interactionsLevel2 = [
  {
    key: 'mouse-click',
    name: 'Mouse Click',
    type: 'level2',
    description: 'Animate on mouse click',
  },
  {
    key: 'mouse-hover',
    name: 'Mouse Hover',
    type: 'level2',
    description: 'Animate when hover on',
  },
  {
    key: 'mouse-leave',
    name: 'Mouse Leave',
    type: 'level2',
    description: 'Animate when mouse leave the object',
  },
  {
    key: 'scroll-into-view',
    name: 'Scroll Into view',
    type: 'level2',
    description: 'Animate when the elements scroll into view or first appear',
  },
  {
    key: 'scrolling-in-view',
    name: 'While scrolling in view',
    type: 'level2',
    description: 'Animate while the elements scroll through view port',
  },
  {
    key: 'after-page-loaded',
    name: 'After page finish loading',
    type: 'level2',
    description: 'Animate trigger after page load',
  },
];

export const interactions = [...interactionsLevel1, ...interactionsLevel2];
